module.exports = __webpack_public_path__ + "img/notify.34f303b3.png";